import { DATA_SOLUTION_COUNT_DATA } from "const/data-solution";
import Container from "../common/Container";
import CounterComponent from "../common/CounterComponent";
import Title from "../common/Title";

const WorkWithUs = () => (
  <Container large className="bg-primary-black py-20 md:py-40">
    <Title
      subTitle="Reasons to work with ultroNeous"
      subTitleClass="text-4xl md:text-6xl text-white text-center pb-12 mb-0 xl:mb-4"
    />
    <CounterComponent
      data={DATA_SOLUTION_COUNT_DATA}
      mainContainerClass="justify-between p-0"
      secondMainContainerClass="lg:w-2/12"
    />
  </Container>
);

export default WorkWithUs;
